import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Divider } from '@kambi/spark';

import classes from '../../App.module.css';
import Description from 'pages/currency-display/components/description/Description';
import FormatNumberWithCurrency from 'pages/currency-display/components/format-number-with-currency/FormatNumberWithCurrency';

const CurrencyDisplay = () => {
    const navigate = useNavigate();

    return (
        <div className={classes.Wrapper}>
            <Button
                color="primary"
                variant="outlined"
                onClick={() => navigate('/')}
            >
                Back
            </Button>
            <div className={classes.Divider}>
                <Divider />
            </div>
            <div className={classes.Content}>
                <div className={classes.Title}>Currency Display</div>
                <div className={classes.Main}>
                    <Description />
                    <FormatNumberWithCurrency />
                </div>
            </div>
        </div>
    );
};

export default CurrencyDisplay;
